import React, {
    useContext,
    useState,
    useEffect,
    useCallback,
    useMemo,
} from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { routeConfirmationModal, DropdownMenuLink } from '@jutro/router';
import { Loader, ModalNextContext, ModalNextEmitter } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import {
    useAuthentication,
    withAuthenticationProvider,
} from '@xengage/gw-digital-auth-react';
import vmTranslator, {
    messages as commonMessages,
} from '@xengage/gw-platform-translations';
import { AccurateBreakpointPropagation } from '@xengage/gw-jutro-adapters-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { ViewModelServiceFactory } from '@xengage/gw-portals-viewmodel-js';
import { AvailabilityService } from 'gw-capability-policycommon';
import { EndorsementService } from 'gw-capability-policychange';
import { PAPolicyChangeWizard } from 'gw-capability-policychange-pa-react';
import { HOPolicyChangeWizard } from 'gw-capability-policychange-ho-react';
import {
    personalizedOfferComponentMap,
    personalizedOfferComponents,
} from 'gw-capability-personalizedoffers-react';
import {
    VehicleInfoLookupComponentMap,
    VehicleInfoLookupComponents,
} from 'gw-capability-vehicleinfo-react';
import {
    policyJobComponentMap,
    policyJobComponents,
} from 'gw-capability-policyjob-react';
import { AdditionalEnrollment } from 'gw-capability-enrollment-react';
import { DigitalWizardCustPageWithTitleTemplate } from 'gw-portals-wizard-components-ui';
import { ProducerInfoService } from 'gw-capability-profileinfo';

import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import {
    AccountBillingDetailsService,
    BillingService,
} from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { ClaimDocumentService } from 'gw-capability-claimdocument';

import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
    LoaderExt,
} from 'gw-components-platform-react';
import {
    cpmiplatformComponentMap,
    cpmiplatformComponents,
    
} from 'cpmi-components-platform-react';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';

import {  ContactAgentPage ,ContactCustomAgentPage} from 'gw-pages-platform-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';

import { ClaimService } from 'gw-capability-claim';
import { FNOLService } from 'gw-capability-fnol';
import { PayrollService } from 'cpmi-capability-payroll'
import { CertificateService } from 'cpmi-capability-certificate'
import { Analytics } from 'cpmi-capability-analytics'
import FaqPage from 'gw-capability-faq-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { filterCapabilityRoutes } from '@xengage/gw-portals-config-js';
import { useBreakpoint } from '@jutro/layout';

import { SubmitPayroll,CPMIStartPayroll,CPMIStartPayrollGL,CPMIStartPayrollCA,PayrollReview,PayrollReviewCA,CPMIStartPayrollMEL,PayrollReviewMEL,PayrollReviewGL } from 'cpmi-capability-payrollreporting-react';
import  UsersProfile from '../pages/cpmi_UsersProfile/UsersProfile'

import ApplicationHeader from '../components/ApplicationHeader/ApplicationHeader';
import UserAdministrationPage from '../pages/UserAdministrationPage/UserAdministrationPage';
import AddNewUser from '../pages/UserAdministrationPage/AddNewUser/AddNewUser'
import CertificatePage from '../pages/CertificatePage/CertificatePage';
import PayrollReportingPage from '../pages/PayrollReportingPage/PayrollReportingPage';
import CreateCertificatePage from '../pages/CertificatePage/CreateCertificate/CreateCertificatePage'
// import EditCertificatePage from '../pages/CertificatePage/EditCertificatePage/EditCertificatePage'
import appRoutes from './App.routes.metadata.json5';
import LandingPage from '../pages/LandingPage/LandingPage';
import SafetyResources from '../pages/SafetyResources/SafetyResources';
import messages from './App.messages';
import MyProfilePage from '../pages/MyProfilePage/MyProfilePage';
import PoliciesPage from '../pages/PoliciesPage/PoliciesPage';
import BaseFNOLWizard, {
    ClaimsConfirmationPage 
} from '../pages/cpmi_FNOL-common';
import FNOLWCWizard from '../pages/cpmi_FNOL-wc';
import {
    ClaimList,
    ClaimDetails,
    PolicyLevelCoverages,
} from '../pages/cpmi_claims';
import {
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents,
    AutomaticPaymentPage,
    PaymentInfoExt
} from '../pages/cpmi_Billing';
import {
    EditCertificate,
    certificateComponentMap,
    certificateAdditionalComponents
} from '../pages/CertificatePage';
import { PolicyDetails } from '../pages/cpmi_PolicyDetailsPage';
import UserAdminDetails from '../pages/UserAdministrationPage/UserAdminDetails/UserAdminDetails'
// import SubmitPayroll from '../pages/PayrollReportingPage/SubmitPayroll/SubmitPayroll';
import BurgerSideMenu from '../components/ApplicationHeader/BurgerSideMenu';
import { getConfigValue } from '@jutro/config';
import {
    subscribe,
    loadGA,
    DefaultDictionaryProvider,
    DefaultWhitelistProvider
} from '@jutro/events';
import  usecpmiAnalytics from '../hooks/usecpmiAnalytics'
const modalEmitter = new ModalNextEmitter();
// import PaymentInfoExt from '../pages/cpmi_Billing/PaymentInfo/PaymentInfoExt'


import { AccountDropDownContextProvider } from '../pages/cpmi_SelectAccountDropDown/components/AccountDropDown/AccountDropDownValuesContext';



import { AppFloorPlan } from '@jutro/legacy/floorplan';



const { capabilitiesConfig, env } = appConfig;

const componentMap = {
    myprofilepage: MyProfilePage,
    landingpage: LandingPage,
    policydocumenterror: PolicyDocumentError,
    fnolwcwizard: FNOLWCWizard,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    ContactCustomAgentPage:ContactCustomAgentPage,
    contactagent: ContactAgentPage,
    fnolpawizard: FNOLPAWizard,
    fnolhowizard: FNOLHOWizard,
    additionalenrollmentpage: AdditionalEnrollment,
    claimlist: ClaimList,
    claimdetails: ClaimDetails,
    policydetailspage: PolicyDetails,
    papolicychangewizard: PAPolicyChangeWizard,
    hopolicychangewizard: HOPolicyChangeWizard,
    billingsummarypage: BillingSummaryPage,
    makepaymentpage: MakePaymentPage,
    AutomaticPaymentPage:AutomaticPaymentPage,
    usersprofile: UsersProfile,
    policylevelcoverages: PolicyLevelCoverages,
    faqpage: FaqPage,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    userAdministrationPage: UserAdministrationPage,
    certificatePage: CertificatePage,
    payrollReportingPage: PayrollReportingPage,
    policiespage:PoliciesPage,
    safetyResources: SafetyResources,
    useradmindetailspage:UserAdminDetails,
    addnewuser:AddNewUser,
    submitpayroll:SubmitPayroll,
    StartPayroll:CPMIStartPayroll,
    StartPayrollGL:CPMIStartPayrollGL,
    StartPayrollMEL:CPMIStartPayrollMEL,
    PayrollReviewMEL:PayrollReviewMEL,
    PayrollReviewGL:PayrollReviewGL,
    StartPayrollCA:CPMIStartPayrollCA,
    PayrollReviewCA:PayrollReviewCA,
    PayrollReview:PayrollReview,
    createCertificatePage:CreateCertificatePage,
    // editCertificatePage:EditCertificatePage,
    EditCertificate:EditCertificate,
    paymentinfo:PaymentInfoExt
   
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...cpmiplatformComponentMap,
        ...personalizedOfferComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...policyJobComponentMap,
        ...billingComponentMap,
        ...certificateComponentMap,
        DigitalWizardCustPageWithTitleTemplate: {
            component: 'DigitalWizardCustPageWithTitleTemplate',
        },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
    },
    {
        ...platformComponents,
        ...cpmiplatformComponents,
        ...personalizedOfferComponents,
        ...VehicleInfoLookupComponents,
        ...policyJobComponents,
        ...billingAdditionalComponents,
        ...certificateAdditionalComponents,
        DigitalWizardCustPageWithTitleTemplate,
        img: ImageComponent,
    }
);

const routesWithTitle = filterCapabilityRoutes(
    capabilitiesConfig,
    appRoutes.routes
);


const renderCustomLoader = (props) => <Loader renderLoader = {() => <LoaderExt />}/>

function App() {
    const auth = useAuthentication();
    const translator = useTranslator();
    const [viewModelService, setViewModelService] = useState(undefined);
    const [routes, updateRoutes] = useState(routesWithTitle);
    const { breakpoint } = useBreakpoint({});
    const ModalNext=useContext(ModalNextContext);
    const renderCustomHeader = (props) => (breakpoint === 'desktop')?<ApplicationHeader {...props} />:<BurgerSideMenu {...props} />;
    
    
    
    const [trackPageView] = usecpmiAnalytics()
    const getAvatarLinks = useCallback(() => {
        return [
            <DropdownMenuLink to="/userprofile">
                {translator(messages.account)}
            </DropdownMenuLink>,
            <DropdownMenuLink to="/faq">
                {translator(messages.faq)}
            </DropdownMenuLink>,
        ];
    }, [translator]);

    const getLogoSrc = useCallback(() => {
        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
        // return `${prefix}/branding/copperpoint-logo-new.png`;
        return `${prefix}/branding/cp_new_logo_updated.png`;

    }, []);

    useEffect(() => {
        
    trackPageView("Home","/home")
    },[])
    
    
    const floorPlansConfig = useMemo(() => {
        return [
            {
                scrollContent: false,
                showFooter: true,
                routes: routesWithTitle,
                footer: appRoutes.footer,
                header: {
                    avatarChildren: getAvatarLinks(),
                    avatarProps: {
                        username: auth.userInfo.name,
                        title: auth.userInfo.name,
                        subtitle: auth.userInfo.name,
                    },
                    logoSrc: getLogoSrc(),
                    showAppSwitcher: false,
                    showNotifications: false,
                },
                renderHeader: 'renderCustomHeader'
                
            },
        ];
    }, [auth, getAvatarLinks, getLogoSrc]);

    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(
                    result,
                    translatorFn
                )
            );
        });
    }, [translator]);

    
    const checkPermissions = useCallback(() => {
        const grantedAuthorities = auth.userInfo.grantedAuthorities;
        const routesToBeUpdated = [];
        let claimUser = false;
        let policyUser = false;
        let payrollUser = false;
        let adminUser = false;
        let billingUser = false;
        let safetyResources = false;
       
        for (const authority of grantedAuthorities) {
            const authorityRegex = /^guidewire\.edge\.(.*)\.(.*)\.(.*)$/g;
            const match = authorityRegex.exec(authority);
            routesToBeUpdated.push(match[3]);
        }

        function route_exists(routesToupdate, val) {
            const result = routesToBeUpdated.findIndex(item => val.toUpperCase() === item.toUpperCase());
        
            if (result !== -1) {
                return true;
            }
        
            return false;
        }

        for (const route of routes) {
            if (
                route_exists(routesToBeUpdated,'useradmin') || route_exists(routesToBeUpdated,'all') 
            ) {
                adminUser = true;   
            }
            if (
                route_exists(routesToBeUpdated,'CLAIM')             ) {
                claimUser = true;  
            }
            if (
                route_exists(routesToBeUpdated,'POLICY')
            ) {
                policyUser = true;
            }
            if (
                route_exists(routesToBeUpdated,'PAYROLL')
            ) {
                payrollUser = true; 
            }
            if (
                route_exists(routesToBeUpdated,'BILLING')
            ) {
                billingUser = true;
            }
            if (
                route_exists(routesToBeUpdated,'safetyresources')
            ) {
                safetyResources = true;
            }
            if(claimUser){
                if (route.path === '/claims' || route.path === '/home') {
                    route.showOnNavBar = true;
                }
               
            }
            if(billingUser){
                if (route.path === '/billing-summary' || route.path === '/home') {
                    route.showOnNavBar = true;
                }
               
            }
            if(payrollUser){
                if (route.path === '/payroll-reporting/list/report' || route.path === '/home') {
                    route.showOnNavBar = true;
                }
               
            }
            if(policyUser){
                if (route.path === '/policiespage' || route.path === '/certificate' || route.path === '/home') {
                    route.showOnNavBar = true;
                }
               
            }
            if(safetyResources){
                if (route.path === '/safety-resources') {
                    route.showOnNavBar = true;
                }
               
            }
            if(adminUser){
                if (
                    route.path === '/user-administration' ||
                    route.path === '/certificate' ||
                    route.path === '/billing-summary' ||
                    route.path === '/claims'||
                    route.path === '/payroll-reporting/list/report'||
                    route.path === '/home'||
                    route.path === '/policiespage' ||
                    route.path === '/safety-resources'
                ) {
                    route.showOnNavBar = true;
                }
            }
        }
        
    }, [auth, routes]);

    const handleError = useCallback(() => {
        return ModalNext.showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
        }).catch(_.noop);
    }, []);
    const handleClick = () => {
        return window.open(
            'https://www.w3schools.com/jsref/met_win_open.asp',
            '_blank'
        );
    };

    const handleFooterLinkClick = () => {
        window.open(`https://www.linkedin.com/company/copperpoint?nocache=${(new Date()).getTime()}`, '_blank');
    };
    
    useEffect(() => {
        sessionStorage.setItem("appNameSession", "CE");
        localStorage.setItem("appNameLocalstorage", "CE");
        document.cookie = "appNameCookie=CE";
        checkPermissions();
    }, [checkPermissions]);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    AccountBillingDetailsService: AccountBillingDetailsService,
                    PolicyService: PolicyService,
                    EndorsementService: EndorsementService,
                    AvailabilityService: AvailabilityService,
                    FNOLService: FNOLService,
                    ClaimService: ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    BillingService: BillingService,
                    EnrollmentService: EnrollmentService,
                    PayrollService: PayrollService,
                    ContactService: ProducerInfoService,
                    CertificateService: CertificateService,
                    Analytics:Analytics
                }}
            >
                <ErrorBoundary onError={handleError}>
                    <ViewModelServiceContext.Provider value={viewModelService}>
                    <AccountDropDownContextProvider>
                        <Router
                            basename="/account-management"
                            getUserConfirmation={(message,callback) => routeConfirmationModal(message,callback,modalEmitter)}>
                            <AppFloorPlan
                                callbackMap={{
                                    renderCustomHeader,
                                    
                                    handleClick,
                                    handleFooterLinkClick,
                                    renderCustomLoader
                                }}
                                componentMap={componentMap}
                                floorPlans={floorPlansConfig}
                            />
                        </Router>
                        </AccountDropDownContextProvider>
                    </ViewModelServiceContext.Provider>
                </ErrorBoundary>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

Loader.defaultProps = {
    renderLoader: () => {
        return <LoaderExt />
    }
}

export default withAuthenticationProvider()(App);
